"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultRowAttributes = exports.defaultProps = exports.defaultColumnAttributes = void 0;

var _interfaces = require("./interfaces");

var defaultProps = {
  shouldScrollHorizontally: true,
  descendingTitleText: 'Sort in descending order',
  ascendingTitleText: 'Sort in ascending order',
  actionHeader: 'Action',
  getRowAttributes: function getRowAttributes() {
    return {};
  }
};
exports.defaultProps = defaultProps;
var defaultRowAttributes = {
  actionLabel: 'More details',
  expandableTriggerText: 'Details',
  shouldVisuallyHideTriggerText: true,
  disabledActionLabel: 'Not available'
};
exports.defaultRowAttributes = defaultRowAttributes;
var defaultColumnAttributes = {
  headerCellType: _interfaces.CellType.Header,
  dataCellType: _interfaces.CellType.Data
};
exports.defaultColumnAttributes = defaultColumnAttributes;